import { api } from '@/helpers/apiClient'
import { logRequestFailure } from '@/helpers/request-outcome'
import { eventGhlDtoSchema, type EventGhlDto } from '@lib/dto/gohighlevel.dto'
import type { PutEventGhlLinksInput } from '@lib/input/gohighlevel.input'
import type { IEventGoHighLevelService } from '@/types/EventGoHighLevelService.types'

/** An event's GoHighLevel section (docs/gohighlevel.spec.md): the leads it came from. */
class EventGoHighLevelServiceImpl implements IEventGoHighLevelService {
  async get(eventId: string): Promise<EventGhlDto> {
    try {
      return await api.get(`/events/${encodeURIComponent(eventId)}/gohighlevel`, eventGhlDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to load an event’s GoHighLevel links', { eventId }, error)
      throw error
    }
  }

  async putLinks(eventId: string, input: PutEventGhlLinksInput): Promise<EventGhlDto> {
    try {
      return await api.put(`/events/${encodeURIComponent(eventId)}/gohighlevel/links`, input, eventGhlDtoSchema)
    } catch (error) {
      logRequestFailure('Failed to change an event’s GoHighLevel links', { eventId }, error)
      throw error
    }
  }
}

export const eventGoHighLevelService: IEventGoHighLevelService = new EventGoHighLevelServiceImpl()
